<template>
  <div class="i-cell-value">
    <a :class="item.uri_id > 0 ? '' : 'disabled'" :href="url" target="_blank"
       :aria-label="newWindowLabel">{{ url }}</a>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  inheritAttrs: false,
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
    url() {
      return this.item.url;
    },
    newWindowLabel() {
      return `${this.LANG.preview} ${this.LANG.opensBlank}`;
    },
  },
  methods: {
  },
});
</script>

<style scoped lang='scss'>
a.disabled {
  pointer-events: none;
  color: #333333;
}
</style>
